import { render, staticRenderFns } from "./FormDatosLegales.vue?vue&type=template&id=d378cc2c&scoped=true"
import script from "./FormDatosLegales.vue?vue&type=script&lang=js"
export * from "./FormDatosLegales.vue?vue&type=script&lang=js"
import style0 from "./FormDatosLegales.vue?vue&type=style&index=0&id=d378cc2c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d378cc2c",
  null
  
)

export default component.exports